export { default } from './HTMLElementType';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/HTMLElementType/index.js
// module id = 196
// module chunks = 25